const enterpriseDomains = ['@morressier.com', '@ioppublishing.org', '@aip.org'];

export const checkEnterpriseUser = (email = '') =>
  !!enterpriseDomains.find(domain => email.endsWith(domain));
